

















import { computed, defineComponent, ref } from '@nuxtjs/composition-api';

import ReadMoreToggle from '~/components/ReadMoreToggle/ReadMoreToggle.vue';

import { getTextContentLineCount } from './getTextContentLineCount';

export default defineComponent({
  name: 'TruncatedReadMoreTextContainer',
  components: {
    ReadMoreToggle,
  },
  props: {
    lines: {
      type: Number,
      default: 5,
    },
    shouldToggle: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const isTruncated = ref<boolean>(true);
    const toggleTruncate = () => {
      isTruncated.value = !isTruncated.value;
    };

    const contentLineCount = ref<number>(-1);
    const setContentLineCount = (number: number) => {
      contentLineCount.value = number;
    };

    const cssComputedProperties = computed<Record<string, number>>(() => ({
      '--line-clamp-lines': props.lines,
    }));

    const conditionalTruncateClass = computed(() => {
      const truncatedClassname = 'truncated-read-more-text-container__text-wrapper--truncated';
      return [{ [truncatedClassname]: isTruncated.value }];
    });

    return {
      isTruncated,
      toggleTruncate,
      cssComputedProperties,
      conditionalTruncateClass,
      contentLineCount,
      setContentLineCount,
    };
  },

  computed: {
    showToggle(): boolean {
      return this.shouldToggle && this.contentLineCount > this.lines;
    },
  },
  /*
   * Line calculation has to occur in mounted as the text content must be rendered
   * before we can calculate the number of lines
   */
  mounted(): void {
    const element: Element = this.$refs?.content as Element;
    this.setContentLineCount(this.getLineCount(element));
  },
  methods: {
    getLineCount(element: Element) {
      return getTextContentLineCount(element);
    },
  },
});
